import {
  getDueDateStatus,
  DUE_DATE_STATUS,
  NUMBER_FORMATTER,
} from '@features/invoices/utils/invoices.utils';

import type { TileDueDateVariant } from './OutstandingAmountTile.types';

export function formatAmountNumber(amount: number | null): string {
  if (amount == null) return '';
  return NUMBER_FORMATTER.format(amount);
}

export function getTileDueDateVariant(dueDate: string | null): TileDueDateVariant {
  const status = getDueDateStatus(dueDate);
  if (status === DUE_DATE_STATUS.PAST_DUE) return 'past-due';
  if (status === DUE_DATE_STATUS.DUE_SOON) return 'due-soon';
  return 'default';
}
